import React, { Component } from 'react'
import Api from './../../../../service/Api';
import Session from '../../../../service/Session';

class List extends Component {
	constructor(props) {
		super(props)
		this.state = {
			items: [],
			params: {
				rut: Session.getInfoUser().rut,
				typeGrilla: 'mantencion',
				campana: props.items.CIA,
				parque: props.items.PARQUE,
				codigo: props.items.SERIE,
				numero: props.items.CONTRATO,
			},
			servicioDA: false,
			servicioDV: true,
			montoMan: 0
		}
	}

	async componentDidMount() {
		let data = await Api.getDataGrilla(this.state.params);
		this.setState({
			items: data
		});
	}

	onClick(e, valor, Tipo) {
		if (e.target.checked) {
			if (Tipo === 'MA') {
				this.setState({
					servicioDA: true,
					servicioDV: false
				});
			} else {
				this.setState({
					servicioDA: true,
					servicioDV: false
				});
			}
		} else {
			if (Tipo === 'MV') {
				this.setState({
					servicioDA: false,
					servicioDV: true
				});
			} else {
				this.setState({
					servicioDA: false,
					servicioDV: true
				});
			}
		}
		this.setState({
			montoMan: e.target.checked ? this.state.montoMan + valor : this.state.montoMan - valor
		});
		this.props.calcularTotal(e, valor, Tipo, this.state.params.numero);
	}

	render() {
		const { items, servicioDA, servicioDV } = this.state;
		return (
			<>
				<div className="content-box-grilla">
					<h3 className="title-lists">
						Mantención
					</h3>
					<table className="table" id="table-green">
						<thead>
							<tr className="head">
								<th scope="col">
									Item
								</th>
								<th scope="col">
									Monto
								</th>
								<th scope="col">
									Seleccionar
								</th>
							</tr>
						</thead>
						<tbody className="body-tr">
							{
								items.length <= 0 ? null : (
									<>
										{parseInt(items.MONTO_MOROSO_MNT) === 0 ? null : (
											<tr>
												<td>Saldo Anterior</td>
												<td align="center">${new Intl.NumberFormat().format(items.MONTO_MOROSO_MNT)}</td>
												<td align="center">
													<input type="checkbox"
														onClick={
															(e) => { this.onClick(e, parseInt(items.MONTO_MOROSO_MNT), "MA") }
														}
														disabled={servicioDA}
													/>
												</td>
											</tr>
										)}
										{parseInt(items.MONTO_VIGENTE_MNT) === 0 ? null : (
											<tr>
												<td>Cuota Vigente</td>
												<td align="center">${new Intl.NumberFormat().format(items.MONTO_VIGENTE_MNT)}</td>
												<td align="center">
													<input type="checkbox"
														onClick={
															(e) => { this.onClick(e, parseInt(items.MONTO_VIGENTE_MNT), "MV") }
														}
														disabled={parseInt(items.MONTO_MOROSO_MNT) === 0 ? false : servicioDV}
													/>
												</td>
											</tr>
										)}
									</>
								)
							}
						</tbody>
					</table>
					<div className="content-total-grilla text-right">Total Mantención ${new Intl.NumberFormat().format(this.state.montoMan)}</div>
				</div>
			</>
		)
	}
}
export default List